module.exports = __webpack_public_path__ + "img/USDT.4d0c9690b.svg";